import React, { useState } from 'react';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import getPreventFromProceedFlag from 'store/product/selector/getPreventFromProceedFlag';
import Spinner from 'components/Common/Spinner/Spinner';
import getPersonalisedButton from 'store/product/selector/getPersonalisedButton';
import getCurrentCategory from 'store/category/selector/getCurrentCategory';
import getEveryItemOutOfStock from 'store/product/selector/getEveryItemOutOfStock';
import gtmSendEvent from 'utils/gtm/gtmSendEvent';
import gtmPpCtaClickEvent from 'utils/gtm/gtmPpCtaClickEvent';
import styles from './PersonaliseButton.module.scss';

interface Props {
  primary?: boolean;
  secondary?: boolean;
}

const PersonaliseButton = ({ primary, secondary }: Props) => {
  const preventFromProceed = useSelector(getPreventFromProceedFlag);
  const isEveryItemOutOfStock = useSelector(getEveryItemOutOfStock);
  const disabled = preventFromProceed || isEveryItemOutOfStock;
  const [redirectInProgress, setRedirectInProgress] = useState(false);
  const { editorLink, buttonLabel } = useSelector(getPersonalisedButton);
  const categoryName = (useSelector(getCurrentCategory) as any)?.name;

  const onClickPersonalise = async (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    gtmSendEvent(gtmPpCtaClickEvent('Personalise', categoryName));
    setRedirectInProgress(true);
    document.location.href = editorLink;
  };

  return (
    <a
      href={editorLink}
      id="PersonaliseButton"
      className={cn(styles.personaliseButton, {
        [styles.disabled]: disabled,
        [styles.running]: redirectInProgress,
        [styles.primary]: primary,
        [styles.secondary]: secondary,
      })}
      onClick={onClickPersonalise}
      data-gtm-event="openEditor"
      data-gtm-editor-version="New"
      data-gtm-category={categoryName}
      rel="nofollow"
    >
      {redirectInProgress && <Spinner className={styles.spinner} />}
      <span>{buttonLabel}</span>
    </a>
  );
};

export default PersonaliseButton;
